import * as Types from 'types/types';
import { RouteState } from './appStateTypes';
import { useAppState } from './GlobalContext';

export function useSelectedCandidate(): {
  selectedCandidate: Types.Candidate | null;
  setSelectedCandidate: (candidate: Types.Candidate | null) => void;
} {
  const { selectedCandidate, setSelectedCandidate } = useAppState();
  return { selectedCandidate, setSelectedCandidate };
}

export function useSelectedJob(): {
  selectedJob: Types.Job | null;
  setSelectedJob: (job: Types.Job | null) => void;
} {
  const { selectedJob, setSelectedJob } = useAppState();
  return { selectedJob, setSelectedJob };
}

export function useSelectedEmployer(): {
  selectedEmployer: Types.Employer | null;
  setSelectedEmployer: (employer: Types.Employer | null) => void;
} {
  const { selectedEmployer, setSelectedEmployer } = useAppState();
  return { selectedEmployer, setSelectedEmployer };
}

export const useSelectedResume = (): {
  selectedResume: Types.Resume | null;
  setSelectedResume: (resume: Types.Resume | null) => void;
} => {
  const { selectedResume, setSelectedResume } = useAppState();
  return { selectedResume, setSelectedResume };
};

export function useRouteState(): {
  routeState: RouteState;
  setActiveTab: (tab: string) => void;
  setFilters: (filters: Record<string, unknown>) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  restoreLastRoute: () => void;
  clearRouteState: () => void;
} {
  const {
    routeState,
    setActiveTab,
    setFilters,
    setSidebarCollapsed,
    restoreLastRoute,
    clearRouteState,
  } = useAppState();

  return {
    routeState,
    setActiveTab,
    setFilters,
    setSidebarCollapsed,
    restoreLastRoute,
    clearRouteState,
  };
}

export function useAppInitializing(): boolean {
  const { isInitializing } = useAppState();
  return isInitializing;
}
